import { NgModule } from '@angular/core';
import { SmartLayoutRoutingModule } from './smart-layout-routing.module';
import { SmartLayoutComponent } from './smart-layout.component';
import { UILoaderModule } from '@apply4u/shared/components/ui-loader/ui-loader.module';
import { ConfirmationModalModule } from '@apply4u/shared/components/confirmation-modal/confirmation-modal.module';
import { SmartHeaderComponent } from '@apply4u/shared/components/smart-header/smart-header.component';
import { SmartFooterComponent } from '@apply4u/shared/components/smart-footer/smart-footer.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    SmartLayoutComponent
  ],
  imports: [   
    RouterModule,     
    SmartHeaderComponent,
    SmartFooterComponent,
    SmartLayoutRoutingModule,
    UILoaderModule,
    ConfirmationModalModule
  ]
})
export class SmartLayoutModule { 

}
